import { api } from '@cems-eco/core/src/services/api';

export abstract class BaseManagementApi {
    BASE_URL: string;

    constructor() {
        this.BASE_URL = "/management";
    }

    async all(): Promise<any> {
        return await api.get<any>(this.BASE_URL);
    }

    async first(id: any): Promise<any> {
        return await api.get<any>(`${this.BASE_URL}/${id}`);
    }

    async getManagementByClient(id: any): Promise<any> {
        return await api.get<any>(`${this.BASE_URL}/detail/${id}`);
    }

    async create(data: any): Promise<any> {
        return await api.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await api.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async destroy(id: any): Promise<any> {
        return await api.delete<any>(`${this.BASE_URL}/${id}`);
    }

    getUrl(url): string {
        return api.getUrl(url);
    }

    async getClientById(id: any): Promise<any> {
        return await api.get<any>(`/client/${id}`);
    }

    async getOptions(url, params): Promise<any[]> {
        let response = await api.get<any>(url, params);
        return (response.data as any[]).map((e) => ({
            label: e.text,
            value: e.id,
        }));
    }

}
